import React from "react";
import type { FormProps } from "antd";
import { Button, Checkbox, Form, Input } from "antd";

import BgImg from "../assets/background.png";
import { LoginUserDto } from "../entities/dto/auth.dto";
import AuthService from "../services/auth.service";
import { useAuth } from "../context/AuthContext";

const Login = () => {
  const { login } = useAuth();

  const onFinish = async (values: LoginUserDto) => {
    const response = await AuthService.login(values);
    if (!response?.success) return;
    login(response.data.access_token);
  };

  return (
    <div
      className="w-full bg-gray-400 flex justify-center items-center h-screen"
      style={{ background: `url(${BgImg})`, backgroundSize: "100%" }}
    >
      <div className="bg-white p-10 rounded-md w-[450px]">
        <div className="mb-6">
          <h1 className="text-3xl font-bold mb-3">Login</h1>
          <p className="text-xl">Welcome back!</p>
        </div>

        <Form
          name="basic"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
        >
          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true, message: "Please input your username!" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item label={null}>
            <Button
              type="primary"
              htmlType="submit"
              className="w-full mt-6"
              size="large"
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Login;
